import SuccessIcon from '@assets/images/success.svg?react'
import { MMButton } from '@components'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'

import './applicationFeeSuccessModal.scss'

const ApplicationFeeSuccessModal = () => {
  const { modalHide } = useContext(GlobalContext)

  return (
    <div className='application-fee-success-wrapper' data-test='application-fee-paid-success'>
      <SuccessIcon />

      <div className='subtitle'>
        {tr('FRONTEND.PAYMENT.SUCCESS', 'Your Application Fee has been paid successfully')}
      </div>

      <MMButton
        type='button'
        size='large'
        color='primary'
        caption={tr('FRONTEND.TRANSFER.BUTTON_OK', 'Ok')}
        onClick={modalHide}
        data-test='button-ok'
        fullWidth
      />
    </div>
  )
}

export default ApplicationFeeSuccessModal
